import { create, StateCreator } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export interface ModalsState {
  invalidEanCode: string | null;
  setInvalidEanCode: (productEan: string | null) => void;
  voucherNotValidReason?: string;
  setVoucherNotValidReason: (reason?: string) => void;
  voucherNotFound: boolean;
  setVoucherNotFound: (value: boolean) => void;
  unknownError: boolean;
  setUnknownError: (value: boolean) => void;
  isSearchModalOpen: boolean;
  toggleIsSearchModalOpen: () => void;
  isInvalidQrModalOpen: boolean;
  setInvalidQrModal: (value: boolean) => void;
  showAgeVerification: boolean;
  setShowAgeVerification: (value: boolean) => void;
}

const initialStateCreator: StateCreator<ModalsState, any> = (set) => ({
  invalidEanCode: null,
  setInvalidEanCode: (invalidEanCode) => {
    set({ invalidEanCode });
  },
  voucherNotValidReason: undefined,
  setVoucherNotValidReason: (voucherNotValidReason) => {
    set({ voucherNotValidReason });
  },
  voucherNotFound: false,
  setVoucherNotFound: (value) => {
    set({ voucherNotFound: value });
  },
  unknownError: false,
  setUnknownError: (value: boolean) => {
    set({ unknownError: value });
  },
  isSearchModalOpen: false,
  toggleIsSearchModalOpen: () => {
    set((state) => ({ ...state, isSearchModalOpen: !state.isSearchModalOpen }));
  },
  isInvalidQrModalOpen: false,
  setInvalidQrModal: (isInvalidQrModalOpen) => {
    set({ isInvalidQrModalOpen });
  },
  showAgeVerification: false,
  setShowAgeVerification: (value) => set({ showAgeVerification: value }),
});

const useModalsStore = create(
  devtools(
    persist(initialStateCreator, {
      name: "modals-storage",
      storage: createJSONStorage(() => sessionStorage),
    })
  )
);

export default useModalsStore;
